import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import GeneratorLandingPage from '@/components/generator-landing-page/GeneratorLandingPage';
import {
  AcademicCapIcon,
  ClockIcon,
  CircleStackIcon,
  ClipboardDocumentListIcon,
  DocumentDuplicateIcon,
  TableCellsIcon
} from '@heroicons/react/24/solid';
import overviewImage from '@/public/docx-landing-image.png';

const imageSection: SectionDetails = {
  miniText: 'Go fast',
  title: 'Flashcards in seconds',
  image: overviewImage,
  description:
    'Limbiks leverages the latest AI technology to create comprehensive flashcards that are easy to consume and focus on the content you need to know.',
  features: [
    {
      name: 'Selectable flashcard types.',
      description:
        'Generate question and answer, fill in the blank, and image occlusion flashcards. Choose the type that works best for you.',
      icon: TableCellsIcon
    },
    {
      name: 'Set flashcard limits.',
      description:
        'Depending on the content and size of file, Limbiks allows you to specify exactly how many flashcards you need.',
      icon: CircleStackIcon
    },
    {
      name: 'Choose pages.',
      description:
        'Generate from every page in your word document or enter the specific pages you want to be used for your flashcards.',
      icon: DocumentDuplicateIcon
    }
  ]
};

const featureSection: SectionDetails = {
  miniText: 'Optimized learning',
  title: 'Advanced AI study tools',
  description:
    'Limbiks offers novel AI study tools so you can master your flashcards.  Our tools are custom built with all of the latest AI advancements to ensure you are getting the best possible study experience.  ',
  features: [
    {
      name: 'Practice Tests',
      description:
        'Take a full practice exam from any of your flashcard decks.  For a comprehensive exam, you can even combine multiple decks. See your results with a full score report including study tips.',
      icon: AcademicCapIcon
    },
    {
      name: 'AI Study Guides',
      description:
        'Generate study guides with every upload.  Limbiks uses AI to analyze your content and build a focused study guide of everything you need to know. All study guides can be downloaded and printed.',
      icon: ClipboardDocumentListIcon
    },
    {
      name: 'Spaced repetition',
      description:
        'Let Limbiks manage your study schedule for you.  Use spaced repition to keep track of due dates for every flashcard. Provide ratings for each card to ensure the perfect schedule.',
      icon: ClockIcon
    }
  ]
};

export default function _DocxToFlashcards() {
  return (
    <GeneratorLandingPage
      imageSection={imageSection}
      featureSection={featureSection}
      title="Word Document to Flashcards"
      description="Upload any Word Document and generate instant flashcards. Whether it is notes, study guides, or reading material, Limbiks can help you learn it all."
    />
  );
}
